module.exports = __webpack_public_path__ + "img/default-player.556e5201.png";